var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-component text-center"},[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50","data-size":"normal","data-flow":"centered"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5","stroke":"#93bfec"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }